// @flow
import React from 'react';
import CardCarousel from '@homeaway/react-card-carousel';
import PropertyCard from './PropertyCard/PropertyCard';
import type {PropertyCardListingShape} from './PropertyCard/PropertyCard';

type Props = {
    isMobile: boolean,
    title: string,
    breakpoints: Object,
    listings: PropertyCardListingShape[],
    checkIn: string
};

const renderCards = (listings, isMobile, checkIn) => {
    return listings.map((listing) => (
        <PropertyCard
            listing={listing}
            isMobile={isMobile}
            key={listing.listingId}
            checkIn={checkIn}
        />
    ));
};

export const PropertyCarousel = (props: Props) => {
    const {isMobile, title, breakpoints, listings, checkIn} = props;

    return (
        <CardCarousel
            breakpoints={breakpoints}
            scrolling={isMobile}
            title={title}
        >
            {renderCards(listings, isMobile, checkIn)}
        </CardCarousel>
    );
};

export default PropertyCarousel;
